<template>
  <div class="content">
    <div class="short-risk">
      <div class="risk-list">
        <div class="risk-item">
          <span>要素/时间</span>
          <span v-for="item, index in riskResult.times" :key="index + ''" v-html="item"></span>
        </div>
        <div class="risk-item" v-for="(item, key)  in riskResult.data" :key="key">
          <span>{{ key }}</span>
          <span v-for="index1 in riskResult.times.length" :key="index1 + ''">
            <i
              :style="{ background: item[index1 - 1] == 1 ? 'red' : item[index1 - 1] == 2 ? 'orange' : item[index1 - 1] == 3 ? '#ffd90a' : item[index1 - 1] == 4 ? 'blue' : item[index1 - 1] == 5 ? '#FFF' : '' }">
              <i class="pounp">{{ riskResult.data[key][index1 - 1] ? levelMap[riskResult.data[key][index1 - 1].toFixed(0)] : '--' }}</i>
            </i>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex'
export default {
  props: ['params', 'forecastType'],
  data () {
    return {
      riskType: 0,
      riskShort: {},
      riskFore: {},
      levelMap: {
        1: '高',
        2: '中',
        3: '低'
      }
    }
  },

  watch: {
    riskForeResult (id) {
      setTimeout(() => {
        this.getRiskData()
      }, 100)
    },
    tqskDateResult: {
      handler () {
        setTimeout(() => {
          this.getRiskData()
        }, 100)
      },
      deep: true
    }
  },
  computed: {
    ...mapState('home', ['objsList', 'activeCountyId', 'cartData', 'riskForeResult']),
    riskResult () {
      const result = {
        times: [],
        data: {}
      }
      if (this.riskFore && this.riskFore.data) {
        const weatherData = this.riskFore.data
        console.log('weatherData', weatherData)
        const weatherTime = this.riskFore.times
        console.log('weatherTime', weatherTime)
        for (const key in weatherData) {
          if (!result.data[key]) {
            result.data[key] = []
          }
          result.data[key].push(...weatherData[key].slice(0, 10))
        }
        const times = weatherTime.slice(0, 10).map(v => {
          if (!v) {
            return ''
          }
          return v.replace('未来', '未来<br>').replace('月', '月<br>')
        })
        result.times.push(...times)
      }
      return result
    }
  },
  mounted () {
    setTimeout(() => {
      this.getRiskData()
    }, 100)
  },
  methods: {
    ...mapMutations('home', ['changeCartItem']),
    /**
     * 短临风险
     */
    async getRiskData () {
      this.riskFore = this.riskForeResult
    }
  }
}
</script>

<style lang="less" scoped>
.content {
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  padding: 1.04vw 1.04vw 1.04vw;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  border-radius: 0.63vw;

  .short-risk {
    height: 100%;
    // padding: 10% 8% 4% 8%;
    // padding: 3.13vw 1.04vw 1.04vw 1.04vw;
    box-sizing: border-box;
  }

  .risk-list {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;

    .risk-item {
      font-size: 0.88rem;
      color: #FFF;
      display: flex;
      justify-content: space-around;
      align-items: center;
      margin-bottom: .6vw;
      &:hover {
        cursor: pointer;
      }

      span:nth-child(1) {
        text-align: center;
        width: 3.64vw;
      }

      span {
        width: 74px;
        display: inline-block;
        text-align: center;
        margin: 0vw 0.16vw;

        i {
          display: inline-block;
          position: relative;
          width: 3.27rem;
          height: 0.63rem;
          background: #295073;
          border-radius: 0.31rem;

          &:hover {
            .pounp {
              display: block;
            }
          }

          .pounp {
            display: none;
            position: absolute;
            bottom: 0.8vw;
            left: 50%;
            transform: translateX(-50%);
            width: 3.27rem;
            height: 1.36vw;
            line-height: 1.36vw;
            background: #052C4D;
            color: #FFF;
            box-shadow: 0px 2px 18px 0px rgba(139, 157, 189, 0.35);
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            -o-text-overflow: ellipsis;

            &::after {
              content: '';
              display: inline-block;
              position: absolute;
              left: 50%;
              bottom: -10px;
              transform: translateX(-50%);
              border: 5px solid transparent;
              border-top-color: rgba(255, 255, 255, 0.8);
              box-shadow: 0px 2px 18px 0px rgba(139, 157, 189, 0.35);
            }
          }
        }
      }
    }

    .risk-item:nth-child(1) {
      height: 2.14vw;
      background: #052C4D;
      border-radius: 0.21vw;
    }
  }
}

.sdrf-title {
  color: #fff;
  font-weight: bold;
  margin-bottom: 1rem;
}
</style>
